module.exports = __webpack_public_path__ + "static/media/harper.3033cd13.jpg";